<template>
  <popup
    :show.sync="is_popup_show"
    width="920px"
    @on-close="is_popup_show = false"
  >
    <div class="text-center top-title">
      {{ is_sample ? "报价寄样信息" : "发大货" }}
    </div>
    <div class="form-wrap">
      <div class="big-delivery" v-if="!is_sample">
        <span class="text-red">温馨提醒：</span>
        <span class="text-666"
          >发大货前请务必先跟客户确认好样品、材质、最终成交价格，双方达成一致后再安排发货！未按流程提前发货产生的退货、返工、经济损失，由发货人自行承担，请规范操作。</span
        >
      </div>
      <!-- 面料采购信息 -->
      <div class="purchase-section">
        <h2 class="form-title">面料采购信息<span class="text-red">*</span></h2>
        <div class="form-label">档口照片+面料实物照片(最多12张)</div>

        <!-- 图片展示区 -->
        <div class="img-upload-area">
          <div
            class="img-item"
            v-for="(item, index) in form_data.image_list"
            :key="index"
          >
            <img :src="item.url" v-viewer />
            <span class="img-close" @click.stop="removeImage(index)">×</span>
          </div>

          <!-- 上传按钮 -->
          <Upload
            action=""
            :data="{ dir: 'template' }"
            :before-upload="(file) => onBeforeUpload(file)"
            :show-upload-list="false"
            multiple
            :format="['jpg', 'jpeg', 'png', 'gif', 'webp']"
            v-if="form_data.image_list.length <= 12"
          >
            <div class="upload-btn">
              <img src="../../../assets/images/procurement/ico_pic.png" />
              <span>上传图片</span>
            </div>
          </Upload>
        </div>

        <!-- 样品基础信息 - 上排：样品名称/成份/材质 -->
        <div class="form-row" v-if="is_sample">
          <div class="form-item">
            <label class="form-label">样品名称</label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.material_name"
              placeholder="请输入样品名称"
            />
          </div>
          <div class="form-item">
            <label class="form-label">成份</label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.ingredient"
              placeholder="请输入成份"
            />
          </div>
          <div class="form-item">
            <label class="form-label">材质</label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.material"
              placeholder="请输入材质"
            />
          </div>
        </div>

        <!-- 样品基础信息 - 下排：克重/幅宽/单位 -->
        <div class="form-row" v-if="is_sample">
          <div class="form-item">
            <label class="form-label">克重</label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.gram_weight"
              placeholder="请输入克重"
            />
          </div>
          <div class="form-item">
            <label class="form-label">幅宽</label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.fabric_width"
              placeholder="请输入幅宽"
            />
          </div>
          <div class="form-item">
            <label class="form-label">单位<span class="text-red">*</span></label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.material_unit"
              placeholder="如：米/码"
            />
          </div>
        </div>

        <!-- 采购信息表单行 -->
        <div class="form-row">
          <div class="form-item">
            <label class="form-label"
              >单价(元/{{ form_data.material_unit || order.material_unit }})<span class="text-red"
                >*</span
              ></label
            >
            <input
              type="number"
              class="form-input"
              v-model="form_data.price"
              placeholder="请输入单价"
            />
          </div>
          <template v-if="is_sample">
            <div class="form-item">
              <label class="form-label"
                >报价数量({{ form_data.material_unit || order.material_unit }})<span class="text-red"
                  >*</span
                ></label
              >
              <input
                type="text"
                class="form-input"
                v-model="form_data.min_quantity"
                placeholder="请输入报价数量"
              />
            </div>
            <div class="form-item">
              <label class="form-label"
                >采购周期(大货)<span class="text-red">*</span></label
              >
              <input
                type="text"
                class="form-input"
                v-model="form_data.cycle"
                placeholder="例:7天内或下单后3-5个工作日"
              />
            </div>
          </template>
          <template v-if="!is_sample">
            <div class="form-item">
              <label class="form-label"
                >大货数量({{ form_data.material_unit || order.material_unit }})<span class="text-red">*</span></label
              >
              <input type="number" class="form-input" v-model="form_data.order_quantity"  placeholder="请输入大货数量" />
            </div>
            <div class="form-item">
              <label class="form-label"
                >发货日期<span class="text-red">*</span></label
              >
              <input type="date" class="form-input" v-model="form_data.delivery_time" />
            </div>
          </template>
        </div>

        <!-- 采购信息（仅面料/辅料显示；打色类型整段不展示） -->
        <template v-if="is_sample && !is_dyeing_type">
          <div class="form-row">
            <div class="form-item">
              <label class="form-label">{{ min_cylinder_label }}</label>
              <input
                type="text"
                class="form-input"
                v-model="form_data.min_cylinder_quantity"
                :placeholder="'请输入' + min_cylinder_label"
              />
            </div>
            <div class="form-item">
              <label class="form-label">染色单色起订量</label>
              <input
                type="text"
                class="form-input"
                v-model="form_data.dye_single_min_quantity"
                placeholder="请输入染色单色起订量"
              />
            </div>
            <div class="form-item">
              <label class="form-label">最低染色单色起订量</label>
              <input
                type="text"
                class="form-input"
                v-model="form_data.dye_lowest_min_quantity"
                placeholder="请输入最低染色单色起订量"
              />
            </div>
             <div class="form-item">
              <label class="form-label">不足染色起订量包缸费</label>
              <input
                type="text"
                class="form-input"
                v-model="form_data.dye_lowest_cylinder_fee"
                placeholder="请输入不足染色起订量包缸费"
              />
            </div>
          </div>
          
        </template>

        <!-- 通用信息 - 上排：不足起订其它费用 / 是否有现货 -->
        <div class="form-row" v-if="is_sample">
          <div class="form-item">
            <label class="form-label">不足起订其它费用</label>
            <input
              type="text"
              class="form-input"
              v-model="form_data.no_min_quantity_other_fee"
              placeholder="请输入不足起订其它费用"
            />
          </div>
          <div class="form-item">
            <label class="form-label">是否有现货</label>
            <select class="form-input" v-model="form_data.has_stock">
              <option value="0">否</option>
              <option value="1">是</option>
            </select>
          </div>
          <div class="form-item">
            <label class="form-label">是否含运费</label>
            <select class="form-input" v-model="form_data.has_shipping">
              <option value="0">否</option>
              <option value="1">是</option>
            </select>
          </div>
        </div>

        <!-- 打色类型专用提示：固定打色卡需求 -->
        <div class="dyeing-tip" v-if="is_sample && is_dyeing_type">
          固定打色卡需求：4份（其中一份为10*10CM大小）
        </div>

      </div>

      <!-- 物流区域 -->
      <div class="sample-area">
        <h2 class="form-title">{{ is_sample ? '寄送小样' : '寄送大货'}}<span class="text-red">*</span></h2>

        <!-- 收货地址 -->
        <div class="address-box">
          <span class="address-tag">收货地址</span>
          <div class="address-text">
            {{ display_contact_person }} {{ display_contact_mobile }}
            {{ display_contact_address }}
          </div>
          <span class="address-copy" @click="copyAddress()">复制</span>
        </div>

        <!-- 物流信息 -->
        <div class="logistics-box">
          <div class="logistics-select">
            <label class="form-label"
              >物流公司<span class="text-red">*</span></label
            >
            <select
              class="form-input margin-left-5"
              placeholder="请选择物流公司"
              v-model="form_data.logistics_name"
            >
              <option value="">请选择</option>
              <option
                v-for="(item, index) in logistics"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </div>
          <div class="logistics-select">
            <label class="form-label"
              >运单号<span class="text-red">*</span></label
            >
            <input
              type="text"
              class="form-input margin-left-5"
              placeholder="请输入运单编号"
              v-model="form_data.logistics_no"
            />
          </div>
        </div>

        <!-- 备注说明 -->
        <div class="remark-box">
          <label class="form-label">备注说明</label>
          <textarea
            class="remark-input"
            placeholder="请输入备注信息(如面料规格、运费说明等)"
          ></textarea>
        </div>

        <!-- 按钮组 -->
        <div class="btn-group">
          <button class="btn btn-cancel" @click="is_popup_show = false">
            取消
          </button>
          <button class="btn btn-submit" @click="confirm()">确认提交</button>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/Popup.vue";
import { OrderDelivery, OrderDeliverySample } from "@/api/procurement.js";
import { uploadFileToOSS } from "@/utils/oss";
import logistics from "@/utils/logistics";
import dayjs from "dayjs";
import { mapState } from "vuex";

export default {
  name: "Delivery",
  data() {
    return {
      is_popup_show: false,
      order: {},
      is_sample: false,
      form_data: {
        image_list: [],
        logistics_name: "",
        logistics_no: "",
        price: "",
        min_quantity: "",
        cycle: "",
        remark: "",
        order_quantity:'',
        delivery_time:dayjs().format("YYYY/MM/DD"),
        uuid:'',
        // 样品基础信息
        material_name: "",
        ingredient: "",
        material: "",
        gram_weight: "",
        fabric_width: "",
        // 单位（可手动填写，初值为代购订单的 material_unit）
        material_unit: "",
        // 采购信息（面料/辅料/打色共用）
        min_cylinder_quantity: "",
        dye_single_min_quantity: "",
        dye_lowest_min_quantity: "",
        dye_lowest_cylinder_fee: "",
        // 通用信息
        no_min_quantity_other_fee: "",
        has_stock: 0,
        has_shipping: 0
      },
      logistics,
    };
  },
  components: {
    Popup,
  },
  props: {},
  computed: {
    ...mapState(["setting"]),
    // 寄样：收货人/手机取内部采购员；寄大货：取仓库地址配置
    display_contact_person() {
      if (this.is_sample && this.order.employee) {
        return this.order.employee.true_name;
      }
      return this.setting.contact_person;
    },
    display_contact_mobile() {
      if (this.is_sample && this.order.employee) {
        return this.order.employee.contact_mobile;
      }
      return this.setting.contact_mobile;
    },
    display_contact_address() {
      if (this.is_sample) {
        return this.setting.sample_address;
      }
      return this.setting.contact_address;
    },
    // 面料类型文案：0 辅料 1 面料 2 打色
    material_type_text() {
      const t = Number(this.order.material_type);
      if (t === 0) return "辅料";
      if (t === 2) return "打色";
      return "面料";
    },
    // 是否为打色类型（打色不展示「开缸起订量」）
    is_dyeing_type() {
      return Number(this.order.material_type) === 2;
    },
    // 开缸起订量字段名：面料=坯起订量，辅料=开机起订量
    min_cylinder_label() {
      return Number(this.order.material_type) === 0 ? "开机起订量" : "坯起订量";
    },
    canSubmit() {
      if (this.is_sample) {
        return (
          this.form_data.image_list &&
          this.form_data.image_list.length > 0 &&
          this.form_data.logistics_name &&
          this.form_data.logistics_no &&
          this.form_data.price !== "" &&
          this.form_data.min_quantity !== "" &&
          this.form_data.cycle !== "" &&
          this.form_data.material_unit !== ""
        );
      }else {
        return (
          this.form_data.image_list &&
          this.form_data.image_list.length > 0 &&
          this.form_data.logistics_name &&
          this.form_data.logistics_no &&
          this.form_data.price !== "" &&
          this.form_data.order_quantity !== ""
        );
      }
    },
  },
  methods: {
    showModal(is_sample, order) {
      this.is_sample = is_sample;
      this.order = order;
      // 初始化 form_data，规避数据残留
      Object.assign(this.form_data, {
        image_list: [],
        logistics_name: "",
        logistics_no: "",
        price: "",
        min_quantity: "",
        cycle: "",
        remark: "",
        order_quantity: "",
        delivery_time: dayjs().format("YYYY/MM/DD"),
        // 样品基础信息
        material_name: order.material_name || "",
        ingredient: "",
        material: "",
        gram_weight: "",
        fabric_width: "",
        // 单位沿用代购订单的 material_unit，初值可手动改
        material_unit: order.material_unit || "",
        // 采购信息（面料/辅料/打色共用）
        min_cylinder_quantity: "",
        dye_single_min_quantity: "",
        dye_lowest_min_quantity: "",
        dye_lowest_cylinder_fee: "",
        // 通用信息
        no_min_quantity_other_fee: "",
        has_stock: 0,
        has_shipping: 0,
        uuid: order.uuid || ""
      });
      this.is_popup_show = true;
    },
    async copyAddress() {
      let text =
        this.display_contact_person +
        " " +
        this.display_contact_mobile +
        " " +
        this.display_contact_address;
      await navigator.clipboard.writeText(text);
      this.$layer.msg("复制成功");
    },
    onBeforeUpload(file) {
      uploadFileToOSS(file, "template").then((url) => {
        this.form_data.image_list.push({
          name: file.name,
          url: url,
        });
      });
      return false;
    },
    removeImage(index) {
      this.form_data.image_list.splice(index, 1);
    },
    async confirm() {
      if (!this.canSubmit) {
        return this.$layer.msg("请填写完整信息");
      }
      try {
        if (this.is_sample) {
          var { code, msg } = await OrderDeliverySample(this.form_data);
        } else {
          var { code, msg } = await OrderDelivery(this.form_data);
        }
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg("提交成功");
        this.is_popup_show = false;
        this.$emit("confirm");
      } catch (e) {
        this.$layer.msg(e.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.top-title {
  font-weight: bold;
  font-size: 20px;
  color: #0f1115;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 0 16px;
}
.form-wrap::-webkit-scrollbar {
  display: none;
}

/* 表单主容器 */
.form-wrap {
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 750px;
  /* 小屏自适应：为标题(约57px)+content padding(20px)预留余量，避免底部按钮被挤出视口 */
  max-height: calc(100vh - 120px);
}
.big-delivery {
  height: 56px;
  background: #f9eaec;
  border-radius: 6px;
  padding: 8px 27px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}

/* 标题样式 */
.form-title {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  margin-top: 10px;
  line-height: 20px;
  position: relative;
  margin-left: 10px;
  &::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 2px;
    width: 3px;
    height: 16px;
    background: #ff5967;
  }
}

/* 图片上传区域 */
.img-upload-area {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 20px;
}

.img-item {
  width: 130px;
  height: 130px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 2px;
  overflow: hidden;
}

.img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 图片关闭按钮 */
.img-close {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  border-radius: 50%;
  cursor: pointer;
}

/* 上传图片占位框 */
.upload-btn {
  width: 130px;
  height: 130px;
  border: 1px dashed #ddd;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
  cursor: pointer;
}

.upload-btn img {
  width: 24px;
  height: 24px;
  margin-bottom: 5px;
}

/* 表单行样式 */
.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  flex: 1;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  margin-top: 14px;
}

.form-label.required::after {
  content: "*";
  color: #ff4d4f;
  margin-left: 3px;
}
.form-item {
  flex: 1;
}
.form-input {
  width: 100%;
  height: 48px;
  padding: 0 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  outline: none;
}

.form-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 寄送小样区域 */
.sample-section {
  margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* 收货地址样式 */
.address-box {
  display: flex;
  align-items: center;
  background-color: #f6f7f9;
  padding: 15px 17px;
  border-radius: 10px;
  margin-bottom: 15px;
  margin-top: 18px;
}

.address-tag {
  background-color: #0066ff;
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-right: 10px;
}

.address-text {
  flex: 1;
  color: #333;
  font-size: 14px;
}

.address-copy {
  color: #0066ff;
  font-size: 12px;
  cursor: pointer;
}

/* 物流信息行 */
.logistics-box {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  height: 88px;
  background: #f6f7f9;
  margin-top: 16px;
  gap: 20px;
  padding: 0 10px;
}

.logistics-select {
  position: relative;
  display: flex;
  padding-right: 5px;
  width: 50%;
}

.logistics-select .form-input {
  padding-right: 30px;
  flex: 1;
}

.waybill-input {
  flex: 2;
}

/* 备注输入框 */
.remark-input {
  width: 100%;
  min-height: 60px;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  resize: vertical;
  outline: none;
}

.remark-input::placeholder {
  color: #999;
}

.remark-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 按钮区域 */
.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  gap: 20px;
  /* 吸底：表单较长时滚动过程中「确认提交」始终可见 */
  position: sticky;
  bottom: -10px; /* 抵消 .form-wrap 的 padding-bottom */
  z-index: 10;
  background: #fff;
  padding: 12px 0;
}

.btn {
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.btn-cancel {
  background-color: #fff;
  border-color: #d9d9d9;
  color: #666;
}

.btn-cancel:hover {
  border-color: #b3b3b3;
  color: #333;
}

.btn-submit {
  background-color: #ff4d4f;
  color: #fff;
  border-color: #ff4d4f;
}

.btn-submit:hover {
  background-color: #ff7875;
}

/* 打色类型专用提示 */
.dyeing-tip {
  margin: 8px 10px 18px;
  padding: 10px 14px;
  background: #fff5f5;
  border: 1px solid #ffd6d6;
  border-radius: 4px;
  color: #ff5967;
  font-size: 13px;
  line-height: 1.6;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .form-row,
  .logistics-row {
    flex-direction: column;
    gap: 15px;
  }
  .waybill-input {
    flex: 1;
  }
  .img-item,
  .upload-placeholder {
    width: 80px;
    height: 80px;
  }
}
</style>
